export default __webpack_public_path__ + "static/media/aggressionIconEmpty.a9805317.svg";